import { render, staticRenderFns } from "./periodoFiltroComponent.vue?vue&type=template&id=51ef04ea"
import script from "./periodoFiltroComponent.ts?vue&type=script&lang=js&external"
export * from "./periodoFiltroComponent.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ef04ea')) {
      api.createRecord('51ef04ea', component.options)
    } else {
      api.reload('51ef04ea', component.options)
    }
    module.hot.accept("./periodoFiltroComponent.vue?vue&type=template&id=51ef04ea", function () {
      api.rerender('51ef04ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/filtros/periodoFiltroComponent.vue"
export default component.exports